import { render } from "./TenantAgoraConfigsManagement.vue?vue&type=template&id=2f567fd2"
import script from "./TenantAgoraConfigsManagement.vue?vue&type=script&lang=js"
export * from "./TenantAgoraConfigsManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__